<!-- TABLE -->
<p-toast></p-toast>
<section class="home__tablebox" *ngIf="isShowTable">
  <div class="table_box">
    <!-- This Section contain "Download as btn", "list-grid view btn" , Detail screen  -->
    <div class="main" *ngIf="IsNoRecordsFound == false">
      <div class="main_rightPart">
        <div
          class="search_data_flexbox_item1 color_black font_20 weight_800"
          *ngIf="totalRecords >= 0"
          style="
            font-size: 18px;
            font-weight: 800;
            background: linear-gradient(90deg, #e78514, #e78514);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          "
        >
          Record(s) Count: <span class="color_blue">{{ totalRecords }}</span>
        </div>
        <!-- <ng-container *ngIf="privilege_json.Download">
          <h5 class="main_rightPart_downloadTitle">Download as :</h5>
          <div class="main_rightPart_downloadBtnBox">
            <div
              class="main_rightPart_downloadBtnBox_btnBox"
              pTooltip="Download as CSV"
              tooltipPosition="top"
              (click)="exportExcel('csv')"
            >
              <div class="main_rightPart_downloadBtnBox_btnBox_iconBox">
                <img
                  src="../../../assets/icons/download-icon.png"
                  alt="Download PDF"
                />
              </div>
              <p class="main_rightPart_downloadBtnBox_btnBox_downloadType">
                CSV
              </p>
            </div>
            <div
              class="main_rightPart_downloadBtnBox_btnBox"
              pTooltip="Download as EXCEL"
              tooltipPosition="top"
              (click)="exportExcel('xlsx')"
            >
              <div class="main_rightPart_downloadBtnBox_btnBox_iconBox">
                <img
                  src="../../../assets/icons/download-icon.png"
                  alt="Download PDF"
                />
              </div>
              <p class="main_rightPart_downloadBtnBox_btnBox_downloadType">
                XLS
              </p>
            </div>
            <div
              class="main_rightPart_downloadBtnBox_btnBox"
              pTooltip="Download as PDF"
              tooltipPosition="top"
              (click)="exportPdf()"
            >
              <div class="main_rightPart_downloadBtnBox_btnBox_iconBox">
                <img
                  src="../../../assets/icons/download-icon.png"
                  alt="Download PDF"
                />
              </div>
              <p class="main_rightPart_downloadBtnBox_btnBox_downloadType">
                PDF
              </p>
            </div>
          </div>
        </ng-container> -->
      </div>
      <div class="main_leftPart">
        <!-- <div class="main_leftPart_sortByBox" *ngIf="isListView">
          <span class="main_leftPart_sortByBox_span">Sort By :</span>
          <p-dropdown
            [options]="cols"
            optionLabel="header"
            optionValue="field"
            [filter]="true"
            placeholder="Sort By"
            styleClass="p-dropdownstyle"
            [(ngModel)]="listSortByfield"
            (onChange)="sortBydata()"
          >
          </p-dropdown>
          <p-radioButton
            name="listsortorder"
            value="ASC"
            label="asc"
            [(ngModel)]="listSortOrder"
            (onClick)="sortBydata()"
          ></p-radioButton>
          <p-radioButton
            name="listsortorder"
            value="DESC"
            label="desc"
            [(ngModel)]="listSortOrder"
            (onClick)="sortBydata()"
          ></p-radioButton>
        </div> -->

        <div class="main_leftPart_other">
          <div
            class="main_leftPart_other_settingBtnBox"
            pTooltip="Fields Setting"
            tooltipPosition="top"
            (click)="isShowFieldSetting = true"
          >
            <img
              src="../../../../assets/icons/setting-white.png"
              alt="setting"
            />
          </div>
          <div
            class="main_leftPart_other_detailViewBtn"
            *ngIf="isListView"
            (click)="showDetailView()"
          >
            Detail View
          </div>
          <div class="main_leftPart_other_gridListBtnBox">
            <div class="main_leftPart_other_gridListBtnBox_gridListViewBox">
              <div
                (click)="isListView = false"
                [ngStyle]="
                  !isListView
                    ? { 'background-color': '#e78514', color: 'white' }
                    : { 'background-color': 'white', color: 'black' }
                "
                class="main_leftPart_other_gridListBtnBox_gridListViewBox_listViewBox"
              >
                <img
                  *ngIf="!isListView"
                  src="../../../assets/icons/list_view_white.png"
                  alt="List View"
                />
                <img
                  *ngIf="isListView"
                  src="../../../assets/icons/list_view_black.png"
                  alt="List View"
                />
                <p>List View</p>
              </div>
              <div
                (click)="isListView = true"
                [ngStyle]="
                  isListView
                    ? { 'background-color': '#e78514', color: 'white' }
                    : { 'background-color': 'white', color: 'black' }
                "
                class="main_leftPart_other_gridListBtnBox_gridListViewBox_gridViewBox"
              >
                <img
                  *ngIf="isListView"
                  src="../../../assets/icons/grid_view_white.png"
                  alt="list"
                />
                <img
                  *ngIf="!isListView"
                  src="../../../assets/icons/grid_view_black.png"
                  alt=""
                />
                <p>Grid View</p>
              </div>
            </div>
          </div>

          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            "
            (click)="exportExcel('csv')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            "
            (click)="exportExcel('xlsx')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>
    </div>

    <div class="border border-danger" *ngIf="false">
      <div class="table__head__two__total">
        <h3>Record(s) Count :</h3>
        <span>{{ this.totalRecords }}</span>
        <button
          *ngIf="isListView == false"
          longPress
          (mouseLongPress)="scrollLeft()"
          (click)="scrollLeft()"
          pTooltip="Long press or click to Scroll Left"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-arrow-left"
          class="p-button-rounded p-button-secondary ml-3"
        ></button>
        <button
          *ngIf="isListView == false"
          longPress
          (mouseLongPress)="scrollRight()"
          (click)="scrollRight()"
          pTooltip="Long press or click to Scroll Right"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-arrow-right"
          class="p-button-rounded p-button-secondary ml-2"
        ></button>
      </div>
      <div class="table__head__two__right">
        <div class="table__head__two__right__sortby" *ngIf="isListView">
          <span>Sort By :</span>
          <p-dropdown
            [options]="cols"
            optionLabel="header"
            optionValue="field"
            [filter]="true"
            placeholder="Sort By"
            styleClass="p-dropdownstyle"
            [(ngModel)]="listSortByfield"
            (onChange)="sortBydata()"
          >
          </p-dropdown>
          <p-radioButton
            name="listsortorder"
            value="ASC"
            label="asc"
            [(ngModel)]="listSortOrder"
            (onClick)="sortBydata()"
          ></p-radioButton>
          <p-radioButton
            name="listsortorder"
            value="DESC"
            label="desc"
            [(ngModel)]="listSortOrder"
            (onClick)="sortBydata()"
          ></p-radioButton>
        </div>
        <button
          type="button"
          pButton
          pRipple
          class="p-button-help mr-2 ml-auto p-btn-stl"
          pTooltip="Raise Query"
          (click)="showRaiseQuery()"
          tooltipPosition="bottom"
          label="Raise Query"
        ></button>
        <button
          *ngIf="IsNoRecordsFound == false"
          (click)="isListView = !isListView"
          pTooltip="Toggle List/Grid View"
          label="Toggle List/Grid View"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          class="p-button-info p-btn-stl"
        ></button>
        <button
          (click)="showDetailView()"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          pTooltip="Detail View"
          label="Detail View"
          class="p-button-warning p-btn-stl"
          *ngIf="isListView == true"
        ></button>
        <!-- <button (click)="showDetailView()" tooltipPosition="bottom" pButton pRipple type="button" pTooltip="Detail View" class="p-button-rounded p-button-warning p-btn-stl" *ngIf="isListView==true"><i class="fa far fa-window-maximize icon-stl"></i></button> -->
        <!-- <button *ngIf="IsNoRecordsFound==false" (click)="isListView=!isListView" pTooltip="Toggle List/Grid View" label="Toggle List/Grid View"  tooltipPosition="bottom" pButton pRipple type="button" [icon]="isListView==true ? 'pi pi-table':'pi pi-align-justify'" class="p-button-info"></button> -->
        <button
          (click)="isShowFieldSetting = true"
          pTooltip="Fields Setting"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-cog"
          class="p-button-rounded p-button-secondary"
        ></button>
        <button
          *ngIf="IsNoRecordsFound == false"
          (click)="exportExcel('csv')"
          pTooltip="Download as CSV"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-file-o"
          class="p-button-rounded p-button-secondary"
        ></button>
        <button
          *ngIf="IsNoRecordsFound == false"
          (click)="exportExcel('xlsx')"
          pTooltip="Download as EXCEL"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-file-excel"
          class="p-button-rounded p-button-success"
        ></button>
        <button
          *ngIf="IsNoRecordsFound == false"
          (click)="exportPdf()"
          pTooltip="Download as PDF"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-file-pdf"
          class="p-button-rounded p-button-danger"
        ></button>
        <button
          (click)="prev()"
          [disabled]="isFirstPage_var"
          pTooltip="Previous Page"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-rounded p-button-secondary"
        ></button>
        <button
          (click)="next()"
          [disabled]="isLastPage_var"
          pTooltip="Next Page"
          tooltipPosition="bottom"
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-rounded p-button-secondary"
        ></button>
      </div>
    </div>
    <div class="" *ngIf="IsNoRecordsFound === true">
      <div class="no-results-container">
        <img
          src="../../../assets/img/no-data.png"
          class="no-results-image"
          alt="No data available"
        />
        <div class="no-results-message color_black">
          <span class="font_20 weight_800">
            Sorry – The search found zero results. Why…
          </span>
          <ul class="no-results-list text_start">
            <li>
              <span class="font_20 weight_500">
                Make sure you have selected the correct search criteria
              </span>
            </li>
            <li>
              <span class="font_20 weight_500">
                Make sure that all words are spelled correctly
              </span>
            </li>
            <li>
              <span class="font_20 weight_500">Try different keywords</span>
            </li>
            <li>
              <span class="font_20 weight_500">Try more general keywords</span>
            </li>
          </ul>
        </div>

        <!-- Back to Search button only if filter was applied -->
        <!-- <button
      class="btn-back-to-search"
      *ngIf="filterAppliedWithNoResults"
      (click)="goBackToSearch()"
    >
      Back to Search
    </button> -->
      </div>
    </div>

    <!-- table VIEW -->
    <div
      id="tabledata"
      style="margin-inline: 29px; border-radius: 5px; position: relative"
    >
      <p-table
        #dt
        *ngIf="!IsNoRecordsFound && !isListView"
        [columns]="cols"
        [value]="products_current_datasource"
        styleClass="p-datatable-gridlines"
        responsiveLayout="scroll"
        scrollDirection="horizontal"
        [scrollable]="true"
        [scrollHeight]="scrollHeight"
        [lazy]="true"
        (onLazyLoad)="loadProducts($event)"
        [lazyLoadOnInit]="false"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading_table"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="TableRowsCounts"
        [globalFilterFields]="globalfilterFields"
        paginatorDropdownAppendTo="body"
        class="table_quik table__stl"
      >
        <!-- ================== COLGROUP ================== -->
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <ng-container *ngFor="let col of columns">
              <col
                *ngIf="col.isDisplay == 1"
                [ngStyle]="{
                  'max-width.px': col.columnWidth,
                  'min-width.px': col.columnWidth
                }"
              />
            </ng-container>
          </colgroup>
        </ng-template>

        <!-- ================== HEADER ================== -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th
                *ngIf="col.isDisplay == 1"
                [pSortableColumn]="col.field"
                [ngStyle]="{
                  'max-width.px': col?.columnWidth,
                  'min-width.px': col?.columnWidth,
                  'background-color': col?.columnColor,
                  border: '1px solid #e9ecef',
                  'padding-inline': '0.2rem',
                  'text-align': col.field === 'S_NO' ? 'center' : 'left'
                }"
              >
                <div style="display: flex; align-items: center">
                  <span>{{ col.header }}</span>
                  <p-sortIcon
                    *ngIf="col.field !== 'S_NO'"
                    [field]="col.field"
                  ></p-sortIcon>
                </div>
              </th>
            </ng-container>
          </tr>

          <!-- FILTERS ROW -->
          <tr>
            <ng-container *ngFor="let col of columns">
              <th
                *ngIf="col.isDisplay == 1"
                [ngStyle]="{
                  'max-width.px': col.columnWidth,
                  'min-width.px': col.columnWidth,
                  border: '1px solid #e9ecef',
                  'padding-inline': '5px'
                }"
              >
                <p-columnFilter
                  *ngIf="col.field !== 'S_NO' && col.fieldDataType !== 'image'"
                  [type]="col.fieldDataType"
                  [field]="col.field"
                  matchMode="contains"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [display]="col.fieldDataType == 'date' ? 'menu' : 'row'"
                  style="max-width: 100%"
                ></p-columnFilter>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <!-- ================== BODY ================== -->
        <ng-template pTemplate="body" let-row let-columns="columns">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td
                *ngIf="col.isDisplay == 1"
                class="table__td"
                [ngStyle]="{
                  'max-width.px': col.columnWidth,
                  'min-width.px': col.columnWidth,
                  'background-color': col.columnColor,
                  padding: '0.2rem',
                  border: '1px solid #e9ecef',
                  'text-align': col.field === 'S_NO' ? 'center' : 'left'
                }"
              >
                <div class="table__tddatabox">
                  <!-- S.NO -->
                  <span
                    *ngIf="col.field === 'S_NO'"
                    appHighlight
                    [searchedWords]="searchedWords"
                    [text]="addDataSpace(row[col.field])"
                    classToApply="highlight__keyword_1"
                  ></span>

                  <!-- PRIMARY TEXT / DATE -->
                  <span
                    *ngIf="
                      col.field !== 'S_NO' &&
                      col.field !== 'iupac' &&
                      col.field !== 'CAsRN' &&
                      col.field !== 'chemcicalClass' &&
                      col.field !== 'mechanismOfActionMoa' &&
                      col.field !== 'chemicalStructure' &&
                      col.field !== 'indication' &&
                      (col.fieldDataType === 'text' ||
                        col.fieldDataType === 'date')
                    "
                    appHighlight
                    [searchedWords]="searchedWords"
                    [text]="addDataSpace(row[col.field])"
                    classToApply="highlight__keyword_1"
                  ></span>

                  <!-- PRIMARY WEBSITE -->
                  <span *ngIf="col.field === 'company_website'">
                    <a target="_blank" [href]="addDataSpace(row[col.field])">
                      {{ addDataSpace(row[col.field]) }}
                    </a>
                  </span>

                  <!-- PRIMARY IMAGE -->
                  <img
                    *ngIf="col.fieldDataType === 'image' && row[col.field]"
                    [src]="getImageUrl(col, row[col.field])"
                    width="40%"
                  />

                  <!-- PRIMARY DOCUMENT -->
                  <span
                    *ngIf="col.fieldDataType === 'document' && row[col.field]"
                  >
                    <a
                      target="_blank"
                      class="btn btn-sm btn-primary"
                      [href]="
                        'https://chemrobotics.com/agropat/' +
                        imageBaseUrls[col.field] +
                        row[col.field]
                      "
                    >
                      <i class="fa fa-download"></i>
                      {{ addDataSpace(row[col.field]) }}
                    </a>
                  </span>

                  <!-- READ MORE -->
                  <button
                    *ngIf="row[col.field]?.length > 65"
                    (click)="
                      showReadMore(col.header, row[col.field], col.show_keyword)
                    "
                    pButton
                    pRipple
                    type="button"
                    label="Read More"
                    class="p-button-info"
                    style="
                      background-color: #e78514;
                      color: white;
                      border-color: #e78514;
                    "
                  ></button>

                  <!-- ========== NEW: SECONDARY DATA (gbrn_products) ========== -->
                  <!-- SECONDARY DATA (GBRN PRODUCTS) -->
                  <div
                    *ngIf="
                      (col.field === 'iupac' ||
                        col.field === 'casRn' ||
                        col.field === 'chemicalClass' ||
                        col.field === 'mechanismOfActionMoa' ||
                        col.field === 'chemicalStructure' ||
                        col.field === 'indication') &&
                      row.gbrn_products?.length
                    "
                    style="margin-top: 3px; color: #555"
                  >
                    <ng-container
                      *ngFor="let obj of row.gbrn_products; let i = index"
                    >
                      <!-- IMAGE FIELD (only for chemicalStructure) -->
                      <div
                        *ngIf="
                          col.field === 'chemicalStructure' && obj[col.field]
                        "
                      >
                        <img
                          [src]="
                            'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                            obj[col.field]
                          "
                          width="40px"
                          style="margin-bottom: 6px"
                        />
                      </div>

                      <!-- TEXT FIELDS -->
                      <div
                        *ngIf="
                          col.field !== 'chemicalStructure' && obj[col.field]
                        "
                      >
                        <small>{{ obj[col.field] }}</small>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>

      <button
        class="rightScrollBtn"
        longPress
        (mouseLongPress)="scrollRight()"
        (click)="scrollRight()"
        pTooltip="Click to Scroll Right"
        tooltipPosition="left"
        *ngIf="IsNoRecordsFound == false && isListView == false"
      >
        <i
          class="pi pi-chevron-right"
          style="color: #e78514; font-size: 1.2"
        ></i>
      </button>
      <button
        class="leftScrollBtn"
        longPress
        (mouseLongPress)="scrollLeft()"
        (click)="scrollLeft()"
        pTooltip="Click to Scroll Left"
        tooltipPosition="right"
        *ngIf="IsNoRecordsFound == false && isListView == false"
      >
        <i
          class="pi pi-chevron-left"
          style="color: #e78514; font-size: 1.2"
        ></i>
      </button>
    </div>
    <div class="row">
      <!-- Card View -->
      <div
        class="table__card"
        [ngClass]="productDetailView ? 'col-6' : 'col-12'"
        *ngIf="IsNoRecordsFound == false && isListView == true"
      >
        <app-card-view></app-card-view>
      </div>
      <!-- Detail View -->
      <div
        ngClass="mt-3 col-6 p-0"
        *ngIf="
          IsNoRecordsFound == false && isListView == true && productDetailView
        "
      >
        <app-detail-view></app-detail-view>
      </div>
    </div>
  </div>
</section>

<!-- Raise Query dialog (Old) -->
<div
  class="modal fade bg_4 fields_modal"
  id="read_more_modal"
  tabindex="-1"
  aria-labelledby="read_more"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg_1" style="position: relative">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="modal-body fields_modal_body">
        <div class="fields_modal_body_top">
          <div
            class="fields_modal_body_top_item1 color_blue font_20 weight_700"
          >
            {{ readMoreColumn }}
          </div>
        </div>
        <div class="fields_modal_body_center">
          <div
            appHighlight
            [searchedWords]="searchedWords"
            [text]="readMoreContent"
            classToApply="highlight__keyword_1"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Column Setting dialog -->
<!-- Column Setting dialog Old -->
<p-dialog
  header="Fields Setting"
  [modal]="true"
  [(visible)]="isShowFieldSetting"
  [style]="{ width: '50vw',}"
  class="column-setting-dialog"
  styleClass="custom-z-index-dialog"
>
  <p-table
    #dt_cols
    [value]="cols"
    *ngIf="cols.length > 0"
    dataKey="field"
    responsiveLayout="auto"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['header']"
  >
    <ng-template pTemplate="caption">
      <div class="d-flex justify-content-between align-items-center">
        <h6>
          Field(s) Count -
          <span style="font-size: 18px; font-weight: 700; color: #e78514">{{
            cols.length.toString()
          }}</span>
        </h6>
        <span class="p-input-icon-left ml-auto userSettingSearchBox">
          <i class="pi pi-search userSettingSearchBox_icon"></i>
          <input
            pInputText
            type="text"
            (input)="globalColFilter($event)"
            placeholder="Search Field"
            class="userSettingSearchBox_input"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Field Name</th>
        <th *ngIf="isListView == false">Width(px)</th>
        <th>Show/Hide</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-col>
      <tr>
        <td>{{ col.header }}</td>
        <td *ngIf="isListView == false">
          <p-inputNumber
            [(ngModel)]="col.columnWidth"
            [allowEmpty]="false"
            [min]="50"
            [max]="1500"
            [showButtons]="true"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
          ></p-inputNumber>
        </td>
        <td>
          <i
            class="pi pi-eye"
            pTooltip="Click here to hide"
            (click)="col.isDisplay = 0"
            [class.hide]="col.isDisplay == 0"
            style="font-size: 1.5rem; cursor: pointer"
          ></i>
          <i
            class="pi pi-eye-slash"
            pTooltip="Click here to show"
            (click)="col.isDisplay = 1"
            [class.hide]="col.isDisplay == 1"
            style="font-size: 1.5rem; cursor: pointer"
          ></i>
          <!-- <fa-icon
            pTooltip="Click here to hide"
            (click)="col.isDisplay = 0"
            [icon]="['fas', 'eye']"
            size="2x"
            [class.hide]="col.isDisplay == 0"
          ></fa-icon>
          <fa-icon
            pTooltip="Click here to show"
            (click)="col.isDisplay = 1"
            [icon]="['fas', 'eye-slash']"
            size="2x"
            [class.hide]="col.isDisplay == 1"
          ></fa-icon> -->
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer" class="d-flex justify-content-end">
    <button
      (click)="saveColumnDetails()"
      pButton
      pRipple
      type="button"
      label="Save"
      class="p-button-rounded p-button-secondary p-button-lg userSettingSaveBtn"
    ></button>
  </ng-template>
</p-dialog>

<!-- Column Setting dialog New -->
<!-- <div
  class="modal fade bg_4 fields_modal"
  id="field_setting_modal"
  tabindex="-1"
  aria-labelledby="sign_in"
  aria-hidden="true"
  *ngIf="cols.length"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg_1">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="modal-body fields_modal_body">
        <div class="fields_modal_body_top">
          <div
            class="fields_modal_body_top_item1 color_blue font_20 weight_700"
          >
            Fields Setting
          </div>
          <div class="fields_modal_body_top_item2">
            <span class="color_black font_16 weight_600">Field(s) Count: </span
            ><span class="color_blue font_16 weight_800">{{
              cols.length
            }}</span>
          </div>
          <div class="fields_modal_body_top_item3">
            <img
              class="fields_modal_body_top_item3_icon"
              src="../../../assets/icons/search_icon.png"
            />
            <input
              type="text"
              placeholder="Search fields"
              class="fields_modal_body_top_item3_input"
            />
          </div>
        </div>
        <div class="fields_modal_body_center">
          <table class="fields_modal_body_center_table">
            <tr
              class="fields_modal_body_center_table_head color_black font_14 weight_600 border-8"
            >
              <th
                class="fields_modal_body_center_table_head_item1 p-y-10 p-x-12"
              >
                Field Name
              </th>
              <th
                class="fields_modal_body_center_table_head_item2 p-y-10 p-x-12"
                *ngIf="isListView"
              >
                Width(px)
              </th>
              <th
                class="fields_modal_body_center_table_head_item3 p-y-10 p-x-12"
              >
                Show/Hide
              </th>
            </tr>
            <ng-container *ngFor="let col of cols">
              <tr
                class="fields_modal_body_center_table_row border-8"
                *ngIf="col.field !== 'S_NO'"
              >
                <td
                  class="fields_modal_body_center_table_row_item1 color_black font_12 weight_500 p-y-10 p-x-12"
                >
                  {{ col.header }}
                </td>
                <td
                  class="fields_modal_body_center_table_row_item2 p-y-10 p-x-12"
                  *ngIf="isListView"
                >
                  <button
                    (click)="decrement(col)"
                    class="fields_modal_body_center_table_row_item2_decrement"
                  >
                    -
                  </button>
                  <input
                    type="number"
                    [(ngModel)]="col.columnWidth"
                    class="fields_modal_body_center_table_row_item2_input"
                  />
                  <button
                    (click)="increment(col)"
                    class="fields_modal_body_center_table_row_item2_increment"
                  >
                    +
                  </button>
                </td>
                <td
                  class="fields_modal_body_center_table_row_item3 p-y-10 p-x-12"
                >
                  <div
                    class="cursor_pointer"
                    *ngIf="col.isDisplay"
                    (click)="col.isDisplay = 0"
                  >
                    <img src="../../../assets/icons/visiblity_icon.png" />
                  </div>
                  <div
                    class="cursor_pointer"
                    *ngIf="!col.isDisplay"
                    (click)="col.isDisplay = 1"
                  >
                    <img src="../../../assets/icons/visiblity_off_icon.png" />
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
        <div class="fields_modal_body_bottom">
          <button
            class="bg_3 color_white font_15 weight_600 border-radius-35 border_none p-x-56 p-y-16"
            (click)="saveColumnDetails()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- long content dialog -->
<p-dialog
  [header]="readMoreColumn"
  [modal]="true"
  [(visible)]="isShowReadMoreDialog"
  [style]="{
    width: '50vw',
    
  }"
>
  <p
    appHighlight
    [searchedWords]="searchedWords"
    [text]="readMoreContent"
    classToApply="highlight__keyword_1"
    style="font-size: 16px; font-weight: 600; color: gray; padding: 24px 20px"
  ></p>
</p-dialog>

<!-- long content dialog secondary table -->
<p-dialog
  [header]="readMoreColumn"
  [modal]="true"
  [(visible)]="isShowReadMoreSecondaryDialog"
  [style]="{ width: '50vw' }"
>
  <div class="row mt-4" *ngFor="let data of readMoreSecondaryContent.data">
    <div class="col">
      <p
        class="mt-3"
        appHighlight
        [searchedWords]="searchedWords"
        [text]="data.value"
        classToApply="highlight__keyword_1"
        *ngIf="
          (readMoreSecondaryContent.dataType === 'text' ||
            readMoreSecondaryContent.dataType === 'date') &&
          readMoreSecondaryContent.column.field !== 'company_website'
        "
      ></p>
      <span *ngIf="readMoreSecondaryContent.column.field === 'company_website'"
        ><a
          target="_blank"
          [href]="addDataSpace(data.value)"
          [text]="addDataSpace(data.value)"
          classToApply="highlight__keyword_1"
        ></a
      ></span>
      <img
        *ngIf="readMoreSecondaryContent.dataType == 'image' && data.value"
        [src]="getImageUrl(readMoreSecondaryContent.column, data.value)"
        alt="Not Available"
        width="40%"
        class="mr-2"
        [ngStyle]="{
          display: 'block',
          margin: '0 auto'
        }"
      />
      <span
        *ngIf="readMoreSecondaryContent.dataType == 'document' && data.value"
      >
        <a
          target="_blank"
          [href]="
            'https://chemrobotics.com/agropat/' +
            imageBaseUrls[readMoreSecondaryContent.column.field] +
            data.value
          "
          class="btn btn-sm btn-primary"
          type="button"
          ><i class="fa fa-download"></i> {{ addDataSpace(data.value) }}</a
        >
      </span>
    </div>
  </div>
</p-dialog>

<!--============================= Search Privilege dialog ================================-->
<!-- Old -->
<!-- <p-dialog
  header="Search Privilege"
  [modal]="true"
  [(visible)]="is_show_Search_Priv_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      You don't have permission to Search, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- New -->
<p-dialog
  header="Search Privilege"
  [(visible)]="is_show_Search_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't have permission to Search, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--=============================  Daily Search Exceed dialog =============================-->
<!-- Old -->
<!-- <p-dialog
  header="Daily Search Exceed"
  [modal]="true"
  [(visible)]="is_show_Daily_Search_Exceed_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      You have exceeded the daily search limit, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- New -->
<p-dialog
  header="Daily Search Exceed"
  [(visible)]="is_show_Daily_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily search limit, please contact the support team
      at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--============================= Total Search Exceed  dialog (Old) =============================-->
<!-- Old -->
<!-- <p-dialog
  header="Total Search Exceed "
  [modal]="true"
  [(visible)]="is_show_Total_Search_Exceed_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      Your search count is exhausted, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- New -->
<p-dialog
  header="Total Search Exceed"
  [(visible)]="is_show_Total_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your search count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--============================= Download  Privilege dialog (Old) ==============================-->
<!-- Old -->
<!-- <p-dialog
  header="Download Privilege"
  [modal]="true"
  [(visible)]="is_show_Download_Priv_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      You don't permission to download, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- New -->
<p-dialog
  header="Download Privilege"
  [(visible)]="is_show_Download_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't permission to download, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--=============================  Daily Download Exceed dialog (Old) =============================-->
<!-- Old -->
<!-- <p-dialog
  header="Daily Download Exceed"
  [modal]="true"
  [(visible)]="is_show_Daily_Download_Exceed_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      You have exceeded the daily download limit, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- New -->
<p-dialog
  header="Daily Download Exceed"
  [(visible)]="is_show_Daily_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily download limit, please contact the support
      team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--=============================  Total Downalod Exceed  dialog (Old) =============================-->
<!-- New -->
<!-- <p-dialog
  header="Total Download Exceed "
  [modal]="true"
  [(visible)]="is_show_Total_Download_Exceed_popup"
  [style]="{ width: '35vw', 'z-index': '9999' }"
>
  <div class="userprivmsg">
    <i class="fa fa-lock" aria-hidden="true"></i>
    <p>
      Your download count is exhausted, <br />
      please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </p>
  </div>
</p-dialog> -->

<!-- Old -->
<p-dialog
  header="Total Download Exceed "
  [(visible)]="is_show_Total_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your download count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>
